import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Apply admin theme to <html> synchronously, BEFORE React mounts. This
// prevents a white flash when the saved theme is dark. The /admin/* routes
// pick this up via useTheme; the public landing forces its own dark class
// on its own root and doesn't depend on this.
(function applyInitialTheme() {
  try {
    const stored = window.localStorage.getItem("clipra-admin-theme");
    let theme = stored === "light" || stored === "dark" ? stored : null;
    if (!theme) {
      theme = window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark";
    }
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.documentElement.style.colorScheme = theme;
  } catch {
    // localStorage disabled — default to dark
    document.documentElement.classList.add("dark");
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
